import { React } from '../../libraries'
import { Heading } from '../atoms'

const FooterContentGeneral = () => {
  return (
    <>
      <Heading ClassName="text-center mb-4" Type="heading-section" Text="General Communication" />
      <p className="leading-tight text-center">For general queries, including partnership opportunities,<br /> please email info@zeroxense.com</p>
    </>
  )
}

export default FooterContentGeneral